import moment from 'moment'

class Attachment {
  constructor(file, identity) {
    this.state = {
      file: file,
      body: file.preview,
      author: identity,
      uploading: true,
      timestamp: moment.now(),
      attributes: {
        contentType: file.type,
      },
    }
  }
}

export default Attachment
